import { Injectable } from '@angular/core';

@Injectable()
export class CurrencyService {
  constructor() { }

  getAllCurrencies(): { code: string, description: string }[] {
    return this.currencies;
  }

  getOneCurrency(code: string): { code: string, description: string } {
    return this.currencies.find(c => { return c.code == code });
  }

  private currencies: { code: string, description: string }[] = [
    { code: "AFN", description: "Afghani" },
    { code: "EUR", description: "Euro" },
    { code: "ALL", description: "Lek" },
    { code: "DZD", description: "Algerian Dinar" },
    { code: "USD", description: "US Dollar" },
    { code: "AOA", description: "Kwanza" },
    { code: "XCD", description: "East Caribbean Dollar" },
    { code: "ARS", description: "Argentine Peso" },
    { code: "AMD", description: "Armenian Dram" },
    { code: "AWG", description: "Aruban Florin" },
    { code: "AUD", description: "Australian Dollar" },
    { code: "AZN", description: "Azerbaijan Manat" },
    { code: "BSD", description: "Bahamian Dollar" },
    { code: "BHD", description: "Bahraini Dinar" },
    { code: "BDT", description: "Taka" },
    { code: "BBD", description: "Barbados Dollar" },
    { code: "BYN", description: "Belarusian Ruble" },
    { code: "BZD", description: "Belize Dollar" },
    { code: "XOF", description: "CFA Franc BCEAO" },
    { code: "BMD", description: "Bermudian Dollar" },
    { code: "INR", description: "Indian Rupee" },
    { code: "BTN", description: "Ngultrum" },
    { code: "BOB", description: "Boliviano" },
    { code: "BOV", description: "Mvdol" },
    { code: "BAM", description: "Convertible Mark" },
    { code: "BWP", description: "Pula" },
    { code: "NOK", description: "Norwegian Krone" },
    { code: "BRL", description: "Brazilian Real" },
    { code: "BND", description: "Brunei Dollar" },
    { code: "BGN", description: "Bulgarian Lev" },
    { code: "BIF", description: "Burundi Franc" },
    { code: "CVE", description: "Cabo Verde Escudo" },
    { code: "KHR", description: "Riel" },
    { code: "XAF", description: "CFA Franc BEAC" },
    { code: "CAD", description: "Canadian Dollar" },
    { code: "KYD", description: "Cayman Islands Dollar" },
    { code: "CLP", description: "Chilean Peso" },
    { code: "CLF", description: "Unidad de Fomento" },
    { code: "CNY", description: "Yuan Renminbi" },
    { code: "COP", description: "Colombian Peso" },
    { code: "COU", description: "Unidad de Valor Real" },
    { code: "KMF", description: "Comorian Franc " },
    { code: "CDF", description: "Congolese Franc" },
    { code: "NZD", description: "New Zealand Dollar" },
    { code: "CRC", description: "Costa Rican Colon" },
    { code: "HRK", description: "Kuna" },
    { code: "CUP", description: "Cuban Peso" },
    { code: "CUC", description: "Peso Convertible" },
    { code: "ANG", description: "Netherlands Antillean Guilder" },
    { code: "CZK", description: "Czech Koruna" },
    { code: "DKK", description: "Danish Krone" },
    { code: "DJF", description: "Djibouti Franc" },
    { code: "DOP", description: "Dominican Peso" },
    { code: "EGP", description: "Egyptian Pound" },
    { code: "SVC", description: "El Salvador Colon" },
    { code: "ERN", description: "Nakfa" },
    { code: "ETB", description: "Ethiopian Birr" },
    { code: "FKP", description: "Falkland Islands Pound" },
    { code: "FJD", description: "Fiji Dollar" },
    { code: "XPF", description: "CFP Franc" },
    { code: "GMD", description: "Dalasi" },
    { code: "GEL", description: "Lari" },
    { code: "GHS", description: "Ghana Cedi" },
    { code: "GIP", description: "Gibraltar Pound" },
    { code: "GTQ", description: "Quetzal" },
    { code: "GBP", description: "Pound Sterling" },
    { code: "GNF", description: "Guinean Franc" },
    { code: "GYD", description: "Guyana Dollar" },
    { code: "HTG", description: "Gourde" },
    { code: "HNL", description: "Lempira" },
    { code: "HKD", description: "Hong Kong Dollar" },
    { code: "HUF", description: "Forint" },
    { code: "ISK", description: "Iceland Krona" },
    { code: "IDR", description: "Rupiah" },
    { code: "XDR", description: "SDR (Special Drawing Right)" },
    { code: "IRR", description: "Iranian Rial" },
    { code: "IQD", description: "Iraqi Dinar" },
    { code: "ILS", description: "New Israeli Sheqel" },
    { code: "JMD", description: "Jamaican Dollar" },
    { code: "JPY", description: "Yen" },
    { code: "JOD", description: "Jordanian Dinar" },
    { code: "KZT", description: "Tenge" },
    { code: "KES", description: "Kenyan Shilling" },
    { code: "KPW", description: "North Korean Won" },
    { code: "KRW", description: "Won" },
    { code: "KWD", description: "Kuwaiti Dinar" },
    { code: "KGS", description: "Som" },
    { code: "LAK", description: "Lao Kip" },
    { code: "LBP", description: "Lebanese Pound" },
    { code: "LSL", description: "Loti" },
    { code: "ZAR", description: "Rand" },
    { code: "LRD", description: "Liberian Dollar" },
    { code: "LYD", description: "Libyan Dinar" },
    { code: "CHF", description: "Swiss Franc" },
    { code: "MOP", description: "Pataca" },
    { code: "MKD", description: "Denar" },
    { code: "MGA", description: "Malagasy Ariary" },
    { code: "MWK", description: "Malawi Kwacha" },
    { code: "MYR", description: "Malaysian Ringgit" },
    { code: "MVR", description: "Rufiyaa" },
    { code: "MRU", description: "Ouguiya" },
    { code: "MUR", description: "Mauritius Rupee" },
    { code: "XUA", description: "ADB Unit of Account" },
    { code: "MXN", description: "Mexican Peso" },
    { code: "MXV", description: "Mexican Unidad de Inversion (UDI)" },
    { code: "MDL", description: "Moldovan Leu" },
    { code: "MNT", description: "Tugrik" },
    { code: "MAD", description: "Moroccan Dirham" },
    { code: "MZN", description: "Mozambique Metical" },
    { code: "MMK", description: "Kyat" },
    { code: "NAD", description: "Namibia Dollar" },
    { code: "NPR", description: "Nepalese Rupee" },
    { code: "NIO", description: "Cordoba Oro" },
    { code: "NGN", description: "Naira" },
    { code: "OMR", description: "Rial Omani" },
    { code: "PKR", description: "Pakistan Rupee" },
    { code: "PAB", description: "Balboa" },
    { code: "PGK", description: "Kina" },
    { code: "PYG", description: "Guarani" },
    { code: "PEN", description: "Sol" },
    { code: "PHP", description: "Philippine Piso" },
    { code: "PLN", description: "Zloty" },
    { code: "QAR", description: "Qatari Rial" },
    { code: "RON", description: "Romanian Leu" },
    { code: "RUB", description: "Russian Ruble" },
    { code: "RWF", description: "Rwanda Franc" },
    { code: "SHP", description: "Saint Helena Pound" },
    { code: "WST", description: "Tala" },
    { code: "STN", description: "Dobra" },
    { code: "SAR", description: "Saudi Riyal" },
    { code: "RSD", description: "Serbian Dinar" },
    { code: "SCR", description: "Seychelles Rupee" },
    { code: "SLL", description: "Leone" },
    { code: "SGD", description: "Singapore Dollar" },
    { code: "XSU", description: "Sucre" },
    { code: "SBD", description: "Solomon Islands Dollar" },
    { code: "SOS", description: "Somali Shilling" },
    { code: "SSP", description: "South Sudanese Pound" },
    { code: "LKR", description: "Sri Lanka Rupee" },
    { code: "SDG", description: "Sudanese Pound" },
    { code: "SRD", description: "Surinam Dollar" },
    { code: "SZL", description: "Lilangeni" },
    { code: "SEK", description: "Swedish Krona" },
    { code: "CHE", description: "WIR Euro" },
    { code: "CHW", description: "WIR Franc" },
    { code: "SYP", description: "Syrian Pound" },
    { code: "TWD", description: "New Taiwan Dollar" },
    { code: "TJS", description: "Somoni" },
    { code: "TZS", description: "Tanzanian Shilling" },
    { code: "THB", description: "Baht" },
    { code: "TOP", description: "Pa’anga" },
    { code: "TTD", description: "Trinidad and Tobago Dollar" },
    { code: "TND", description: "Tunisian Dinar" },
    { code: "TRY", description: "Turkish Lira" },
    { code: "TMT", description: "Turkmenistan New Manat" },
    { code: "UGX", description: "Uganda Shilling" },
    { code: "UAH", description: "Hryvnia" },
    { code: "AED", description: "UAE Dirham" },
    { code: "USN", description: "US Dollar (Next day)" },
    { code: "UYU", description: "Peso Uruguayo" },
    { code: "UYI", description: "Uruguay Peso en Unidades Indexadas (URUIURUI)" },
    { code: "UZS", description: "Uzbekistan Sum" },
    { code: "VUV", description: "Vatu" },
    { code: "VEF", description: "Bolívar" },
    { code: "VND", description: "Dong" },
    { code: "YER", description: "Yemeni Rial" },
    { code: "ZMW", description: "Zambian Kwacha" },
    { code: "ZWL", description: "Zimbabwe Dollar" },
  ]
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/shared/services/currency.service.ts